<template>
  <div class="rersouce_study_recordTB">
    <el-table :data="list" style="width: 100%"
        :header-cell-style="{
          background: '#F0F0F0',
          fontSize: '14px',
          height: '50px',
          fontWeight: 500,
          color: '#333',
        }">
      <el-table-column label="ID" align="center" prop="id" />
      <!-- <el-table-column
        label="姓名"
        align="center"
        prop="truename"
        sortable="custom"
      /> -->
      <el-table-column
        label="资源学习方式"
        align="center"
        prop="resources_study_type"
      />
      <el-table-column
        label="此次完成进度"
        align="center"
        prop="complete_rate"
        :formatter="formatter"
      />
      <el-table-column label="学习终端" align="center" prop="is_complete" />
      <el-table-column label="学习时间" align="center" prop="complete_time" />
    </el-table>
  </div>
</template>

<script>
export default {
    props:{
        list:{
            type:Array
        }
    },
  data() {
    return {};
  },
  methods: {
    formatter(row, column) {
      let complete_rate = row.complete_rate || 0;
      return complete_rate + "%";
    },
  },
};
</script>
 
<style lang = "less" scoped>
.rersouce_study_recordTB {
    padding-bottom: 24px;
}
</style>